"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsSnowplowReady = void 0;
const react_1 = __importDefault(require("react"));
const useSnowplowTracker_1 = __importDefault(require("./hooks/useSnowplowTracker"));
const SnowplowContext = react_1.default.createContext({
    isSnowplowReady: false,
});
/**
 * Context Provider for Snowplow
 *
 * @param props all required and optional props for the Tracker initialization
 */
const SnowplowProvider = ({ configuration, children }) => {
    const isSnowplowReady = (0, useSnowplowTracker_1.default)(configuration);
    return (react_1.default.createElement(SnowplowContext.Provider, { value: { isSnowplowReady } }, children));
};
const useIsSnowplowReady = () => {
    const { isSnowplowReady } = react_1.default.useContext(SnowplowContext);
    return isSnowplowReady;
};
exports.useIsSnowplowReady = useIsSnowplowReady;
exports.default = SnowplowProvider;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU25vd3Bsb3dQcm92aWRlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9yZWFjdC9Tbm93cGxvd1Byb3ZpZGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxrREFBMEI7QUFHMUIsb0ZBQTREO0FBTTVELE1BQU0sZUFBZSxHQUFHLGVBQUssQ0FBQyxhQUFhLENBQXNCO0lBQzdELGVBQWUsRUFBRSxLQUFLO0NBQ3pCLENBQUMsQ0FBQztBQUVIOzs7O0dBSUc7QUFDSCxNQUFNLGdCQUFnQixHQUFHLENBQUMsRUFBRSxhQUFhLEVBQUUsUUFBUSxFQUFpQixFQUFnQixFQUFFO0lBQ2xGLE1BQU0sZUFBZSxHQUFHLElBQUEsNEJBQWtCLEVBQUMsYUFBYSxDQUFDLENBQUM7SUFFMUQsT0FBTyxDQUNILDhCQUFDLGVBQWUsQ0FBQyxRQUFRLElBQUMsS0FBSyxFQUFFLEVBQUUsZUFBZSxFQUFFLElBQUcsUUFBUSxDQUE0QixDQUM5RixDQUFDO0FBQ04sQ0FBQyxDQUFDO0FBRUssTUFBTSxrQkFBa0IsR0FBRyxHQUFZLEVBQUU7SUFDNUMsTUFBTSxFQUFFLGVBQWUsRUFBRSxHQUFHLGVBQUssQ0FBQyxVQUFVLENBQUMsZUFBZSxDQUFDLENBQUM7SUFDOUQsT0FBTyxlQUFlLENBQUM7QUFDM0IsQ0FBQyxDQUFDO0FBSFcsUUFBQSxrQkFBa0Isc0JBRzdCO0FBRUYsa0JBQWUsZ0JBQWdCLENBQUMifQ==


// WEBPACK FOOTER //
// ../../../src/react/SnowplowProvider.tsx